import { render, staticRenderFns } from "./imgUpload.vue?vue&type=template&id=a08ec5c4&scoped=true"
import script from "./imgUpload.vue?vue&type=script&lang=js"
export * from "./imgUpload.vue?vue&type=script&lang=js"
import style0 from "./imgUpload.vue?vue&type=style&index=0&id=a08ec5c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08ec5c4",
  null
  
)

export default component.exports